// extracted by mini-css-extract-plugin
module.exports = {"bonuses":"_82e3db2ea0--bonuses--sFOef","desktop":"_82e3db2ea0--desktop--S34Jn","with-extended":"_82e3db2ea0--with-extended--WBFGr"};